import { render, staticRenderFns } from "./usekresponsivewindow.vue?vue&type=template&id=d923d124&scoped=true"
import script from "./usekresponsivewindow.vue?vue&type=script&lang=js"
export * from "./usekresponsivewindow.vue?vue&type=script&lang=js"
import style0 from "./usekresponsivewindow.vue?vue&type=style&index=0&id=d923d124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d923d124",
  null
  
)

export default component.exports